import { Button, Dialog, DialogContent, DialogTitle, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { BoxedUrlWithCopy as BoxedTokenWithCopy } from 'components';
import { useSCIMTokenContext } from 'context';
import { MAX_ACTIVE_TOKENS } from 'pages/Firms/pages/ScimConfiguration/constants';

const TokenGenerator = () => {
  const { tokens, generateToken, newlyCreatedToken, setNewlyCreatedToken } = useSCIMTokenContext();
  const theme = useTheme();
  const downMd = useMediaQuery(theme.breakpoints.down('md'));

  const areMaxActiveTokensReached = (tokens ?? []).filter(t => t.revoked_at === null).length === MAX_ACTIVE_TOKENS;

  return (
    <>
      <Button
        disabled={areMaxActiveTokensReached || tokens === null}
        onClick={generateToken}
        variant="contained"
        sx={{ width: 'fit-content' }}>
        Generate New Token
      </Button>
      {areMaxActiveTokensReached ? (
        <Typography variant="body2">
          Maximum number of active tokens reached. Please revoke an existing token to generate a new one.
        </Typography>
      ) : null}
      <Dialog open={!!newlyCreatedToken} onClose={() => setNewlyCreatedToken(null)} fullWidth fullScreen={downMd}>
        <DialogTitle>SCIM Token Generated</DialogTitle>
        <DialogContent>
          <Typography variant="body1" gutterBottom>
            Please copy this token and use it in your SCIM client.
          </Typography>
          <BoxedTokenWithCopy url={newlyCreatedToken?.raw_token as string} />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default TokenGenerator;
